// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.RentalManagerUserPropertyActivateV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyActivateV2WebApiHandler_activate } from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyActivateResponseV2WebDto,
  UserPropertyActivateV2RequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyActivateV2WebApiHandler_activate_Args {
  postData: UserPropertyActivateV2RequestDto;
}

export type RentalManagerUserPropertyActivateV2WebApiHandler_activate_Options = UseMutationOptions<
  UserPropertyActivateResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyActivateV2WebApiHandler_activate_Args
>;

/**
 * Activate a property
 */
export const useRentalManagerUserPropertyActivateV2WebApiHandler_activate = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyActivateV2WebApiHandler_activate_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyActivateV2WebApiHandler_activate_Args) =>
      RentalManagerUserPropertyActivateV2WebApiHandler_activate(args.postData, httpClient),
  });
};
